import { render, staticRenderFns } from "./gridComponent.vue?vue&type=template&id=25185b04&scoped=true&"
import script from "./gridComponent.vue?vue&type=script&lang=js&"
export * from "./gridComponent.vue?vue&type=script&lang=js&"
import style0 from "./gridComponent.vue?vue&type=style&index=0&id=25185b04&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25185b04",
  null
  
)

export default component.exports